import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <>
      <div className="container-fluid nav_bg">
        <div className="row">
          <div className="col-10 mx-auto">
            <div>
              <nav className="navbar navbar-expand-lg  ">
                <div className="container-fluid">
                  <NavLink className="navbar-brand" to="/">
                    React App
                  </NavLink>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
                      <li className="nav-item">
                        <NavLink
                          style={({ isActive }) => ({
                            color: isActive ? "Black" : "Gray",
                            borderBottom: isActive?"2px solid black" :"none",
                          })}
                          exact
                          className="nav-link active "
                          aria-current="page"
                          to="/"
                        >
                          Home
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          style={({ isActive }) => ({
                            color: isActive ? "Black" : "Gray",
                            borderBottom: isActive?"2px solid black" :"none",
                          })}
                          className="nav-link"
                          to="/service"
                        >
                          Services
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          style={({ isActive }) => ({
                            color: isActive ? "Black" : "Gray",
                            borderBottom: isActive?"2px solid black" :"none",
                          })}
                          className="nav-link "
                        // className={ ({isActive})=>(isActive ? "menu_active" : "")}
                          to="/about"
                        >
                          About
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          style={({ isActive }) => ({
                            color: isActive ? "Black" : "Gray",
                            borderBottom: isActive?"2px solid black" :"none",
                          })}
                          className="nav-link"
                          to="/contact"
                        >
                          Contact
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
